<template>

          <div class="event"
      @mousedown.self="startDrag($event)" 
      :style="{
      width: event.width + 'px',
      left: event.left + 'px',
      top: (event.top) + 'px',
      'border-top':  '3px solid ' + event.color,
      'background-color': LightenDarkenColor(event.color),
      opacity: event.ondrag ? '0.2' : 'inherit',
      boxShadow: event.ondrag ? '0 0 8px rgba(0, 0, 0, 0.4)' : 'none',
      transform: event.ondrag ? 'scale(1.02)' : 'scale(1)',
    }">
            <div 
            @mousedown.self="startDrag($event)" 
              @mouseenter="event.hover = true" 
              @mouseleave="event.hover = false" 
              
              class="event_title">

              <div  @mousedown.self="startDrag($event)"  style="font-weight:bold; font-size:10px">{{ event.name }} - {{ event.contact }}</div>
             {{ event.start.format("DD/MM") }} - {{ event.end.format("DD/MM") }}
            </div>
            <div 

              @mouseenter="event.hover = true" 
              @mouseleave="event.hover = false" 
              @mousedown.stop="$emit('startResize', $event)"
              v-if="event.hover"
              class="event_drag" 
              
             >
              <svg xmlns="http://www.w3.org/2000/svg" height="15" viewBox="0 96 960 960" width="15" fill="#464646">
                <path
                  d="M340.442 919q-32.876 0-57.659-24.292t-24.783-57Q258 803 282.624 779.5t57.5-23.5Q373 756 396.5 778.925t23.5 58.217q0 33.292-23.341 57.575Q373.319 919 340.442 919Zm281.355 0q-32.877 0-57.337-24.292t-24.46-57Q540 803 564.455 779.5t57.094-23.5q33.051 0 56.751 22.925Q702 801.85 702 837.142q0 33.292-23.664 57.575Q654.673 919 621.797 919ZM340.442 657q-32.876 0-57.659-24.455T258 574.951Q258 541 282.624 518t57.5-23Q373 495 396.5 518.089q23.5 23.088 23.5 56.539 0 33.452-23.341 57.912Q373.319 657 340.442 657Zm281.355 0q-32.877 0-57.337-24.455T540 574.951Q540 541 564.455 518t57.094-23q33.051 0 56.751 23.089 23.7 23.088 23.7 56.539 0 33.452-23.664 57.912Q654.673 657 621.797 657ZM340.442 396q-32.876 0-57.659-24.455T258 313.951q0-33.551 24.624-57.251 24.624-23.7 57.5-23.7Q373 233 396.5 256.664q23.5 23.663 23.5 57.039 0 33.377-23.341 57.837Q373.319 396 340.442 396Zm281.355 0q-32.877 0-57.337-24.455T540 313.951q0-33.551 24.455-57.251Q588.91 233 621.549 233q33.051 0 56.751 23.664 23.7 23.663 23.7 57.039 0 33.377-23.664 57.837Q654.673 396 621.797 396Z" />
              </svg>
            </div>

            <!-- Container icone con altezza 100% dell'elemento -->
            <div class="icons-wrapper"   @mouseenter="event.hover = true" 
              @mouseleave="event.hover = false" style="user-select: all;  pointer-events: all;">
              <!-- Icone per activities e tasks raggruppate per giorno -->
              <div v-for="(dayItem, index) in event.dayItems" :key="'day-' + index" 
                class="day-column"
                :style="{ left: dayItem.positionLeft + dayItem.width / 2 - 9  + 'px'}">
                <!-- Icona unica per tutte le attività del giorno -->
                <span class="activity-icon-button"  @click.stop="handleActivityClick($event,dayItem.activities, dayItem.activities.length === 1 ? dayItem.activities[0] : null)" v-if="dayItem.activities.length > 0" :title="dayItem.activities.map(a => a.name).join(', ')" style="display: flex;">
                
                <svg 
                    class="icon activity-icon"
                    xmlns="http://www.w3.org/2000/svg" height="10" viewBox="0 96 960 960" width="10" fill="#ffffff"
                  
                  >
                    <path d="M200 976q-33 0-56.5-23.5T120 896V336q0-33 23.5-56.5T200 256h56V216q0-17 11.5-28.5T296 176q17 0 28.5 11.5T336 216v40h288V216q0-17 11.5-28.5T664 176q17 0 28.5 11.5T704 216v40h56q33 0 56.5 23.5T840 336v560q0 33-23.5 56.5T760 976H200Zm0-80h560V416H200v480Z"/>
                  </svg>
                </span>
                <!-- Icona unica per tutti gli incarichi del giorno -->
                <span  @click.stop="handleTaskClick($event,dayItem.tasks, dayItem.tasks.length === 1 ? dayItem.tasks[0] : null)" v-if="dayItem.tasks.length > 0" :title="dayItem.tasks.map(t => t.name).join(', ')" style="display: flex;">
                  <svg 
                    class="icon task-icon"
                    xmlns="http://www.w3.org/2000/svg" height="10" viewBox="0 96 960 960" width="10" fill="#ffffff"
                  >
                    <path d="M382 816h396q17 0 28.5-11.5T818 776q0-17-11.5-28.5T778 736H382q-17 0-28.5 11.5T342 776q0 17 11.5 28.5T382 816Zm0-172h396q17 0 28.5-11.5T818 604q0-17-11.5-28.5T778 564H382q-17 0-28.5 11.5T342 604q0 17 11.5 28.5T382 644Zm0-172h396q17 0 28.5-11.5T818 432q0-17-11.5-28.5T778 392H382q-17 0-28.5 11.5T342 432q0 17 11.5 28.5T382 472ZM182 816q-17 0-28.5-11.5T142 776q0-17 11.5-28.5T182 736q17 0 28.5 11.5T222 776q0 17-11.5 28.5T182 816Zm0-172q-17 0-28.5-11.5T142 604q0-17-11.5-28.5T182 564q17 0 28.5 11.5T222 604q0 17-11.5 28.5T182 644Zm0-172q-17 0-28.5-11.5T142 432q0-17 11.5-28.5T182 392q17 0 28.5 11.5T222 432q0 17-11.5 28.5T182 472Z"/>
                  </svg>
                </span>
              </div>
              </div>
    </div>

</template>


<script>
import "dayjs/locale/it";
export default {
  name: "gant-grid-event",
  props: ["event"],
  watch: {
  },
  methods: {
    handleActivityClick(event, activities, activity) {

      if (activities.length > 1) {
        this.$emit('open-activities', activities);
      } else {
        this.$emit('open-activity', activity);
      }
    },
    startDrag(event) {
      console.log(event);
      this.$emit('startDrag', event);
    },  
    handleTaskClick(event, tasks, task) {

      if (tasks.length > 1) {
        this.$emit('open-tasks', tasks);
      } else {
        this.$emit('open-task', task);
      }
    },
     HexToRgb(val) {
      if (val.length != 6) {
        throw "Only six-digit hex colors are allowed.";
      }

      var aRgbHex = val.match(/.{1,2}/g);
      var aRgb = [
        parseInt(aRgbHex[0], 16),
        parseInt(aRgbHex[1], 16),
        parseInt(aRgbHex[2], 16),
      ];
      return aRgb;
  },
  rgb2hsl(rgbArr) {
      var r1 = rgbArr[0] / 255;
      var g1 = rgbArr[1] / 255;
      var b1 = rgbArr[2] / 255;

      var maxColor = Math.max(r1, g1, b1);
      var minColor = Math.min(r1, g1, b1);
      //Calculate L:
      var L = (maxColor + minColor) / 2;
      var S = 0;
      var H = 0;
      if (maxColor != minColor) {
        //Calculate S:
        if (L < 0.5) {
          S = (maxColor - minColor) / (maxColor + minColor);
        } else {
          S = (maxColor - minColor) / (2.0 - maxColor - minColor);
        }
        //Calculate H:
        if (r1 == maxColor) {
          H = (g1 - b1) / (maxColor - minColor);
        } else if (g1 == maxColor) {
          H = 2.0 + (b1 - r1) / (maxColor - minColor);
        } else {
          H = 4.0 + (r1 - g1) / (maxColor - minColor);
        }
      }

      L = L * 100;
      S = S * 100;
      H = H * 60;
      if (H < 0) {
        H += 360;
      }
      var result = [H, S, L];
      return result;
  },
  LightenDarkenColor(col) {
      
      if (col[0] == "#") {
        col = col.slice(1);
      }
      var hsl = this.rgb2hsl(this.HexToRgb(col));
      hsl[2] = 85;
      //return '#aaaaaa30';
      return `hsl(${hsl[0]} ${hsl[1]}% ${hsl[2]}% / 50%)`;
  },
  }
};
</script>

<style scoped>
.events-container {
  height: 200px;
  height: 100%;
  position: relative;
}

.event {
  z-index: 1;
  display: flex;
  color: #000000;
  position: absolute;
  border-radius: 3px;
  padding: 4px 4px;
  overflow: hidden;
  box-sizing: border-box;
  white-space: nowrap;
  display: flex;
  align-items: center;
  height: 34px;
  cursor: pointer;
  border: 0.5px solid #fff;
  transition: all 0.15s cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-user-select: none;
  /* Safari */
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* IE10+/Edge */
  user-select: none;
  /* Standard */
}

.icons-wrapper {
  height: 100%;
  display: flex;
  align-items: center;
  position: absolute;
  left:0px;
}

.day-column {
  position: absolute;
  display: flex;
  flex-direction: column;
  gap: 2px;
  
  align-items: center;
  justify-content: center;
  height: 100%;

}

.icon {
  width: 12px;
  height: 12px;
  cursor: pointer;
  transition: all 0.2s;
  z-index: 10;
}

.activity-icon {
  padding: 1px;
  border-radius: 4px;
  background-color: #FF6B6B;
}

.activity-icon:hover {
  background-color: #FF5252;
  transform: scale(1.05);
}

.task-icon {
  padding: 1px;
  border-radius: 4px;
  background-color: #4A90E2;
}

.task-icon:hover {
  background-color: #357ABD;
  transform: scale(1.05);
}

.activity-dot {
  position: absolute;
  top: 4px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #ff0000;
  transform: translateX(-50%);
  border: 1px solid #fff;
  cursor: pointer;
  z-index: 10;
}

.activity-dot:hover {
  background-color: #ff5252;
}

.task-dot {
  position: absolute;
  bottom: 4px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #0066ff;
 transform: translateX(-50%);
  border: 1px solid #fff;
  cursor: pointer;
  z-index: 10;
}

.task-dot:hover {
  background-color: #357ABD;
}

.event .event_drag {
  min-width: 10px;
  display: flex;
  align-items: center;
}

.event_title {
  flex-grow: 1;
  text-align: start;
  min-width: 0px;
  font-size: 12px;
}

.event:hover {
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
}

.hide {
  left: -120px!important;
}

.hide_segment{
  --translate-x: 0px!important;
}

.noselect {
  -webkit-touch-callout: none;
  /* iOS Safari */
  -webkit-user-select: none;
  /* Safari */
  -khtml-user-select: none;
  /* Konqueror HTML */
  -moz-user-select: none;
  /* Old versions of Firefox */
  -ms-user-select: none;
  /* Internet Explorer/Edge */
  user-select: none;
  /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}



.by-scroll-container::-webkit-scrollbar-track {
  background-color: #fff;
}

.by-scroll-container::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  background-color: #F5F5F5;
}

.by-scroll-container::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
  background-color: #999;
}
</style>